import { http } from '../../config/axios'

 const getNotificacao = (): Promise<any> => {
 
  return http
    .get('api/notificacao/listarnotificacoes/')
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro getNotificacao', error)
      throw Error(error.response.data)
    })
}

export default getNotificacao;
